import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const kipchak: UnitJsonConfig = {
    id: 'kipchak',
    unitName: defineMessage({ message: 'Kipchak' }),
    stats: {
        hp: 65,
        stamina: 120,
        speed: 5,
        armor: 8,
        evasion: 10,
        armorPenetration: 0.0,
        rangedSkill: 90,
        critChance: 15,
        critMult: 1.3,
        initiative: 38,
        damageMin: 9,
        damageMax: 12,
    },
    skills: [
        {
        id: 'c_ar_quick',
        name: defineMessage({ message: 'Arrow Shot' }),
        sort: 10,
        cost: 50,
        range: 5,
        powerMult: 1,
        hitChanceBonus: 5,
        iconRow: 4,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.5,
        y: 0.69,
    },
    badge: {
        x: 60,
        y: -190,
    },
    unitPortrait: {
        row: 1,
        col: 1,
    }
} satisfies UnitJsonConfig;
